module.exports = __webpack_public_path__ + "media/images/icon__facebook@2x-ed06bcba0c38b50a16ecca256b066bf5.png";